/* js/components/socialShare/Twitter.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	assign,
	attr,
	compute_rest_props,
	create_component,
	destroy_component,
	detach,
	exclude_internal_props,
	get_spread_object,
	get_spread_update,
	init,
	insert,
	mount_component,
	safe_not_equal,
	svg_element,
	transition_in,
	transition_out
} from "svelte/internal";

import ShareButton from './ShareButton.svelte';

function create_default_slot(ctx) {
	let svg;
	let path;

	return {
		c() {
			svg = svg_element("svg");
			path = svg_element("path");
			attr(path, "d", "M23.44 4.83c-.8.37-1.5.38-2.22.02.93-.56.98-.96 1.32-2.02-.88.52-1.86.9-2.9 1.1-.82-.88-2-1.43-3.3-1.43-2.5 0-4.55 2.04-4.55 4.54 0 .36.03.7.1 1.04-3.77-.2-7.12-2-9.36-4.75-.4.67-.6 1.45-.6 2.3 0 1.56.8 2.95 2 3.77-.74-.03-1.44-.23-2.05-.57v.06c0 2.2 1.56 4.03 3.64 4.44-.67.2-1.37.2-2.06.08.58 1.8 2.26 3.12 4.25 3.16C5.78 18.1 3.37 18.74 1 18.46c2 1.3 4.4 2.04 6.97 2.04 8.35 0 12.92-6.92 12.92-12.93 0-.2 0-.4-.02-.6.9-.63 1.96-1.22 2.56-2.14z");
			attr(svg, "xmlns", "http://www.w3.org/2000/svg");
			attr(svg, "viewBox", "0 0 24 24");
		},
		m(target, anchor) {
			insert(target, svg, anchor);
			append(svg, path);
		},
		d(detaching) {
			if (detaching) detach(svg);
		}
	};
}

function create_fragment(ctx) {
	let sharebutton;
	let current;

	const sharebutton_spread_levels = [
		{
			class: "ssbc-button--twitter " + /*classes*/ ctx[1]
		},
		/*$$restProps*/ ctx[3],
		{ ariaLabel: /*ariaLabel*/ ctx[0] },
		{ href: /*href*/ ctx[2] }
	];

	let sharebutton_props = {
		$$slots: { default: [create_default_slot] },
		$$scope: { ctx }
	};

	for (let i = 0; i < sharebutton_spread_levels.length; i += 1) {
		sharebutton_props = assign(sharebutton_props, sharebutton_spread_levels[i]);
	}

	sharebutton = new ShareButton({ props: sharebutton_props });

	return {
		c() {
			create_component(sharebutton.$$.fragment);
		},
		m(target, anchor) {
			mount_component(sharebutton, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const sharebutton_changes = (dirty & /*classes, $$restProps, ariaLabel, href*/ 15)
			? get_spread_update(sharebutton_spread_levels, [
					dirty & /*classes*/ 2 && {
						class: "ssbc-button--twitter " + /*classes*/ ctx[1]
					},
					dirty & /*$$restProps*/ 8 && get_spread_object(/*$$restProps*/ ctx[3]),
					dirty & /*ariaLabel*/ 1 && { ariaLabel: /*ariaLabel*/ ctx[0] },
					dirty & /*href*/ 4 && { href: /*href*/ ctx[2] }
				])
			: {};

			if (dirty & /*$$scope*/ 64) {
				sharebutton_changes.$$scope = { dirty, ctx };
			}

			sharebutton.$set(sharebutton_changes);
		},
		i(local) {
			if (current) return;
			transition_in(sharebutton.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(sharebutton.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(sharebutton, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	const omit_props_names = ["text","url","ariaLabel","class"];
	let $$restProps = compute_rest_props($$props, omit_props_names);
	let { text } = $$props;
	let { url } = $$props;
	let { ariaLabel = 'Share on Twitter' } = $$props;
	let { class: classes = '' } = $$props;
	let href;

	$$self.$$set = $$new_props => {
		$$props = assign(assign({}, $$props), exclude_internal_props($$new_props));
		$$invalidate(3, $$restProps = compute_rest_props($$props, omit_props_names));
		if ('text' in $$new_props) $$invalidate(4, text = $$new_props.text);
		if ('url' in $$new_props) $$invalidate(5, url = $$new_props.url);
		if ('ariaLabel' in $$new_props) $$invalidate(0, ariaLabel = $$new_props.ariaLabel);
		if ('class' in $$new_props) $$invalidate(1, classes = $$new_props.class);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*text, url*/ 48) {
			$: $$invalidate(2, href = encodeURI(`https://twitter.com/intent/tweet/?text=${text}&url=${url}`));
		}
	};

	return [ariaLabel, classes, href, $$restProps, text, url];
}

class Twitter extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { text: 4, url: 5, ariaLabel: 0, class: 1 });
	}
}

export default Twitter;